<template>
  <div>
     <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="background: url('/static/img/newsletter.svg'); background-position: top !important;"
        ></div>
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">{{ $t("subscribe_to_our_newsletter") }}</div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div class="pt-8">
      <div class="row disablerow align-items-start">
        <!-- Left Area -->
        <div class="col-xl-9 innercreatetraining subscription_news">
          <!-- confirmed -->
          <div class="sto_newsletter_popup">
            <img
              class="newsletter_v_arrow"
              src="/static/img/sub_bluetick.svg"
            />
            <h3 class="align_center">{{ $t("subscription_confirmed") }}</h3>
            <p class="nl_p1">
               {{ $t("thank_you_for_verifying_your_email") }}<br />
               {{ $t("your_newsletter_subscription_is_now_active") }}
            </p>
            <p class="nl_p2">
                             {{ $t("look_out_for_the_latest_updates") }}
            </p>
            <v-card-actions class="">
              <v-btn
                @click="cancelSubscription"
                outlined
                depressed
                tile
                class="savebutton"
              >
                {{ $t("browse_training_programs") }}</v-btn
              >
            </v-card-actions>
          </div>
        </div>

        <!-- Right Area -->
        <div class="col-xl-3 ml-1 px-0 pl-md-12 pl-lg-8 row pt-0 onlyContact">
          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      subscriptionId: null,
    };
  },

  mounted() {
    this.subscriptionId = this.$route.query.subscriptionId;
    if (this.subscriptionId) {
      this.finalSubscrptionConfirmation(this.subscriptionId);
    } else {
      this.$router.push("/subscription-module");
    }
  },

  methods: {
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },

    onFinally() {
      showLoadingCircle(false);
    },
    cancelSubscription() {
      sessionStorage.removeItem("subscriptionData");
      this.$router.push("/categories");
    },
    finalSubscrptionConfirmation() {
      var _this = this;
      this.$axios
        .put("api/newsletter/" + this.subscriptionId)
        .then(function (response) {
          if (response.data.alreadySubscribed == false) {
            _this.dialogConfirmationFinal = true;
          }
        })
        .catch(this.onError);
    },
  },
};
</script>
